import { AuthenticationService } from '../services/authentication.service';
import { MarketplacePermission } from '../services/authentication.interface';
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';

import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable()
export class ClaimGuard {
  constructor(
    private auth: AuthenticationService,
    private router: Router,
  ) {}

  canActivateChild(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.auth.permission$.pipe(
      filter((p: MarketplacePermission) => p.claims?.length > 0),
      map((_) => {
        const hasClaims = this.auth.hasClaims(route.data.claims);
        if (hasClaims) {
          return true;
        } else {
          // Send user to the business information page if the user doesn't have permission to that page
          // when switching between accounts.
          this.router.navigate(['/business/information/account']);
        }
      }),
    );
  }
}
